import React, { useEffect, useState } from "react";

import { useParams } from "react-router-dom";

import { methods } from "api/methods";
import { Ingredient } from "api/models";
import { resources } from "api/resources";
import { useApi } from "api/useApi";
import { PageLoadStateProvider } from "components/common";

import IngredientsDetailsForm from "./IngredientsDetailsForm";
import IngredientsDetailsHeader from "./IngredientsDetailsHeader";

const IngredientsDetailsPage: React.FC = () => {
  const execute = useApi();
  const params = useParams();
  const [ingredientData, setIngredientData] = useState<Ingredient>();
  const [breadcrumbName, setBreadcrumbName] = useState<string>();

  useEffect(() => {
    if (params.ingredientKey) {
      execute(resources.ingredient(params.ingredientKey), methods.GET)
        .then((response: Ingredient) => {
          setIngredientData(response);
          setBreadcrumbName(response.name);
        })
        .catch(() => {});
    } else {
      execute(resources.newIngredient, methods.GET)
        .then((response: Ingredient) => {
          if (!response.isInvalid) {
            setIngredientData(response);
            setBreadcrumbName(response.name);
          }
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.ingredientKey]);

  return (
    <PageLoadStateProvider isLoaded={!!ingredientData?.translations}>
      <IngredientsDetailsHeader
        ingredient={ingredientData}
        displayName={breadcrumbName}
      />
      <IngredientsDetailsForm
        ingredient={ingredientData}
        onNameSaved={setBreadcrumbName}
      />
    </PageLoadStateProvider>
  );
};

export default IngredientsDetailsPage;
